import { render, staticRenderFns } from "./secondary-button.vue?vue&type=template&id=7e4c516f&scoped=true"
import script from "./secondary-button.vue?vue&type=script&lang=js"
export * from "./secondary-button.vue?vue&type=script&lang=js"
import style0 from "./secondary-button.vue?vue&type=style&index=0&id=7e4c516f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e4c516f",
  null
  
)

export default component.exports